import { CLIENT_STAGES } from './assignment_stage'

export const ASSIGNMENT_STATUS: {
  [key in AssignmentStatus]: {
    id: AssignmentStatus
    title: string
    title_extended: string // used in filter title
    color: string
    stage: string
  }
} = {
  CLO_AWA: {
    id: 'CLO_AWA',
    title: 'New Request',
    title_extended: 'New Request',
    color: 'blue',
    stage: CLIENT_STAGES?.new?.title || ''
  },
  READY: {
    id: 'READY',
    title: 'Ready for Category',
    title_extended: 'Ready for Category',
    color: 'blue',
    stage: CLIENT_STAGES?.ready?.title || ''
  },
  WRO_AWA: {
    id: 'WRO_AWA',
    title: 'Unallotted',
    title_extended: 'Unallotted',
    color: 'blue',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  WRO_RJT: {
    id: 'WRO_RJT',
    title: 'Unallotted',
    title_extended: 'Unallotted (Writer Passed)',
    color: 'blue',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  WRI_AWA: {
    id: 'WRI_AWA',
    title: 'AWA',
    title_extended: 'AWA',
    color: 'gold',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  WRI_WRK: {
    id: 'WRI_WRK',
    title: 'Writing',
    title_extended: 'Writing',
    color: 'gold',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDO_AWA: {
    id: 'EDO_AWA',
    title: 'Written',
    title_extended: 'Written / Translated / Designed',
    color: 'orange',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDO_RJT: {
    id: 'EDO_RJT',
    title: 'Written',
    title_extended: 'Written / Translated (Editor Passed)',
    color: 'orange',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDI_AWA: {
    id: 'EDI_AWA',
    title: 'AEA',
    title_extended: 'AEA',
    color: 'cyan',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDI_WRK: {
    id: 'EDI_WRK',
    title: 'Editing',
    title_extended: 'Editing',
    color: 'cyan',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDO_FIN: {
    id: 'EDO_FIN',
    title: 'Edited',
    title_extended: 'Edited (by Creator)', // since `EDO_FIN` is automatically upgraded to CLO_FIN
    color: 'geekblue',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  CLO_FIN: {
    id: 'CLO_FIN',
    title: 'Edited',
    title_extended: 'Edited',
    color: 'geekblue',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  CLI_AWA: {
    id: 'CLI_AWA',
    title: 'Submitted',
    title_extended: 'Submitted',
    color: 'purple',
    stage: CLIENT_STAGES?.finished?.title || ''
  },
  CLI_FIN: {
    id: 'CLI_FIN',
    title: 'Approved',
    title_extended: 'Approved',
    color: 'green',
    stage: CLIENT_STAGES?.approved?.title || ''
  },
  EDI_RWK: {
    id: 'EDI_RWK',
    title: 'Rework',
    title_extended: 'Rework (Editor Rework)',
    color: 'magenta',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDO_RWK: {
    id: 'EDO_RWK',
    title: 'Rework',
    title_extended: 'Rework (Editor Ops Rework)',
    color: 'magenta',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  CLO_RWK: {
    id: 'CLO_RWK',
    title: 'Rework',
    title_extended: 'Rework (Client Ops Rework)',
    color: 'magenta',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  CLI_RWK: {
    id: 'CLI_RWK',
    title: 'Rework',
    title_extended: 'Rework (Client Rework)',
    color: 'magenta',
    stage: CLIENT_STAGES?.rejected?.title || ''
  },
  CLI_RJT: {
    id: 'CLI_RJT',
    title: 'Rejected by Client',
    title_extended: 'Rejected by Client',
    color: 'red',
    stage: CLIENT_STAGES?.rejected?.title || ''
  },
  WRI_RJT: {
    id: 'WRI_RJT',
    title: 'Writer Rejected',
    title_extended: 'Writer Rejected',
    color: 'red',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  EDI_RJT: {
    id: 'EDI_RJT',
    title: 'Editor Rejected',
    title_extended: 'Editor Rejected',
    color: 'red',
    stage: CLIENT_STAGES?.in_progress?.title || ''
  },
  HOLD: {
    id: 'HOLD',
    title: 'On Hold',
    title_extended: 'On Hold',
    color: 'magenta',
    stage: CLIENT_STAGES?.hold?.title || ''
  },
  SCRAPPED: {
    id: 'SCRAPPED',
    title: 'Scrapped',
    title_extended: 'Scrapped',
    color: 'magenta',
    stage: CLIENT_STAGES?.scrapped?.title || ''
  }
}
